import { useConfirmation } from '@wyz/ui';
import { invariant, useOnMount } from '@wyz/utils';
import { useAuth } from 'react-oidc-context';
import { useManageUsers } from '~/common/api';
import { useApplicationContext, useI18n } from '~/common/context';
import { useNavigate } from 'react-router';

const CookieConsentModal = () => {
  const { t } = useI18n();
  const ask = useConfirmation();
  const auth = useAuth();
  const manageUsers = useManageUsers({
    acceptCookieConsent: { enabled: true },
  });

  const { application } = useApplicationContext();
  const navigate = useNavigate();

  useOnMount(() => {
    ask({
      title: t('app.common.cookie_consent.title'),
      description: t('app.common.cookie_consent.description'),
      confirmBtnText: t('app.common.cookie_consent.accept_button'),
      backdrop: 'static',
      confirmBtnClass: 'confirm-or-close-modal',
      closeBtnClass: 'confirm-or-close-modal',
    })
      .onConfirm(() => {
        invariant(auth.user?.profile.sub);
        manageUsers.acceptCookieConsent.mutate(
          {
            id: auth.user?.profile.sub,
          },
          {
            onSuccess: () => {
              if (application.entities.length === 0) {
                return;
              }
              void navigate(`/customers/${application.entities[0].id}`);
            },
          },
        );
      })
      .onCancel(() => {});
  });
  return <></>;
};

export default CookieConsentModal;
